import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { App, Form, Card, Row, Col, Button, Avatar, Tabs, Spin, Alert,Divider,Radio,Space,Checkbox, Typography  } from 'antd';
import { ArrowLeftOutlined, UserOutlined, EditOutlined } from '@ant-design/icons';
import { getClientById } from '../../services/clients';
import { resolveMedia } from '../../utils/media';
import { listGenders, listMainGoals, listFitnessLevels } from '../../services/catalogs';
import '../../styles/global.css';
import dayjs from 'dayjs';
import { lookupPostalCode, lookupPostalCodeById } from '../../services/geo';
import ClientSubscriptionsHistory from './ClientSubscriptionsHistory';
const { useApp } = App;

const ClientViewPage = () => {
    const { Title } = Typography;
    const { id } = useParams();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('client');
    const [genders, setGenders] = useState([]);
    const [goals, setGoals] = useState([]);
    const [levels, setLevels] = useState([]);
    const { message } = useApp();
    // Cargar catálogos
    useEffect(() => {
        (async () => {
            try {
                const [g, m, f] = await Promise.all([
                    listGenders(),
                    listMainGoals(),
                    listFitnessLevels(),
                ]);
                setGenders(g);
                setGoals(m);
                setLevels(f);
            } catch (e) {
                console.error(e);
                message.error('No se pudieron cargar los catálogos');
            }
        })();
    }, [message]);

    useEffect(() => {
            
        if (!id) {
        setError('ID no proporcionado');
        setLoading(false);
        return;
        }

        const loadData = async () => {
        try {
            setLoading(true);
            setError(null);
            const data = await getClientById(id);
            // Si hay postal_code_id intenta reconstruir ciudad/estado (si el backend ofrece el endpoint opcional)
            if (data?.postal_code_id) {
                const geo = await lookupPostalCodeById(data.postal_code_id);
                if (geo) {
                        data.postal_code = geo.postal_code;
                        data.city_name = geo?.municipality?.name || geo?.city || '';
                        data.state_name = geo?.state?.name || '';
                }
            }
            setData(data);
        } catch (err) {
            console.error('Error al cargar:', err);
            setError('No se pudo cargar la información');
        } finally {
            setLoading(false);
        }
        };

        loadData();
    }, [id]);

  const handleEdit = () => {
    navigate(`/clients/${id}/edit`);
  };

  const handleBack = () => {
    navigate('/clients/all');
  };

  if (loading) {
    return (
      <div style={{ padding: 24, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: 24 }}>
        <Alert
          message="Error"
          description={error}
          type="error"
          showIcon
          action={
            <Button size="small" onClick={handleBack}>
              Volver
            </Button>
          }
        />
      </div>
    );
  }

  if (!data) {
    return (
      <div style={{ padding: 24 }}>
        <Alert
          message="Dato no encontrado"
          description="El dato solicitado no existe o no se pudo cargar."
          type="warning"
          showIcon
          action={
            <Button size="small" onClick={handleBack}>
              Volver
            </Button>
          }
        />
      </div>
    );
  }

  // Formatear teléfono si existe
  const formatPhone = (phone) => {
    if (!phone) return 'No disponible';
    // Formato: XXX-XXXX-XXX
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length === 10) {
      return `${cleaned.substring(0, 3)}-${cleaned.substring(3, 7)}-${cleaned.substring(7)}`;
    }
    return phone;
  };

  return (
    <div style={{ padding: 24, margin: '0 auto' }}>
      {/* Header */}
      <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Button 
            type="text" 
            icon={<ArrowLeftOutlined style={{ fontSize: '24px', strokeWidth: 4 }} />} 
            onClick={handleBack}
            style={{ 
              padding: 0,
              color: '#262626',
              fontSize: '24px',
              fontWeight: '100',
              height: 'auto'
            }}
          />
          <Title level={3} style={{ marginBottom: 0 }}>Detalles de cliente</Title>
        </div>

        <Button 
          type="text" 
          icon={<EditOutlined style={{ fontSize: '24px', strokeWidth: 4 }} />} 
          onClick={handleEdit}
          style={{ 
            padding: 0,
            color: '#262626',
            fontSize: '24px',
            fontWeight: '100',
            height: 'auto'
          }}
        />
      </div>

      <Card
        style={{
          borderRadius: '32px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}
      >

                    <Tabs
                        activeKey={activeTab}
                        onChange={setActiveTab}
                        destroyInactiveTabPane={false}
                        items={[
                            {
                                key: 'client',
                                label: 'Cliente',
                                children: (
                                    
                                            <Row gutter={16}>
                                            <Col xs={24} md={8} className='col-spaced'>
                                                <div className="field-label">
                                                Nombre
                                                </div>
                                                <div className="field-value">
                                                {data.first_name || 'No disponible'}
                                                </div>
                                            </Col>
                                            <Col xs={24} md={16} className='col-spaced'>
                                                <div className="field-label">
                                                Apellidos
                                                </div>
                                                <div className="field-value">
                                                {data.last_name || 'No disponible'}
                                                </div>
                                            </Col>
                                            {/* <Col xs={24} md={8} className='col-spaced'>
                                                <div className="field-label">
                                                Apellido Materno
                                                </div>
                                                <div className="field-value">
                                                {data.second_last_name || 'No disponible'}
                                                </div>
                                            </Col> */}

                                            <Col xs={24} md={8} className='col-spaced'>
                                                <div className="field-label">
                                                Correo Electrónico
                                                </div>
                                                <div className="field-value">
                                                {data.email || 'No disponible'}
                                                </div>
                                            </Col>

                                            <Col xs={24} md={6} className='col-spaced'>
                                                <div className="field-label">
                                                    Teléfono móvil
                                                </div>
                                                <div className="field-value">
                                                {formatPhone(data.mobile_phone) || 'No disponible'}
                                                </div>
                                            </Col>

                                            <Col xs={24} md={5} className='col-spaced'>
                                                <div className="field-label">
                                                    Fecha de nacimiento
                                                </div>
                                                <div className="field-value">
                                                {data.birth_date || 'No disponible'}
                                                </div>
                                            </Col>

                                            <Col xs={24} md={5} className='col-spaced'>
                                                <div className="field-label">
                                                    Género
                                                </div>
                                                <div className="field-value">
                                                  {genders?.find(gender => gender.id === data.gender_id)?.name || 'No disponible'}
                                                </div>
                                            </Col>
                                            <Col xs={24} md={8} className='col-spaced'>
                                                <div className="field-label">
                                                    Código Postal
                                                </div>
                                                <div className="field-value">
                                                {data.postal_code || 'No disponible'}
                                                </div>
                                            </Col>
                                            <Col xs={24} md={8} className='col-spaced'>
                                                <div className="field-label">
                                                    Ciudad
                                                </div>
                                                <div className="field-value">
                                                {data.city_name || 'No disponible'}
                                                </div>
                                            </Col>
                                            <Col xs={24} md={8} className='col-spaced'>
                                                <div className="field-label">
                                                    Estado
                                                </div>
                                                <div className="field-value">
                                                {data.state_name || 'No disponible'}
                                                </div>
                                            </Col>
                                            <Col xs={24} md={24}>
                                                <Divider orientation="left">Perfil Fitness</Divider>
                                            </Col>

                                            <Col xs={24} md={12} className='col-spaced'>
                                                <div className="field-label">
                                                    Objetivo Principal
                                                </div>
                                                <div className="field-value">
                                                {goals?.find(goals => goals.id === data.main_goal_id)?.name || 'No disponible'}
                                                </div>
                                            </Col>
                                            <Col xs={24} md={12} className='col-spaced'>
                                                <div className="field-label">
                                                    Nivel de condición física
                                                </div>
                                                <div className="field-value">
                                                {levels?.find(levels => levels.id === data.fitness_level_id)?.name || 'No disponible'}
                                                </div>
                                            </Col>
                                            <Col xs={24} md={6} className='col-spaced'>
                                                <div className="field-label">
                                                    Altura (cm)
                                                </div>
                                                <div className="field-value">
                                                {data.height_cm || 'No disponible'}
                                                </div>
                                            </Col>
                                            <Col xs={24} md={6} className='col-spaced'>
                                                <div className="field-label">
                                                    Peso (kg)
                                                </div>
                                                <div className="field-value">
                                                {data.weight_kg || 'No disponible'}
                                                </div>
                                            </Col>   
                                            <Col xs={24} md={6} className='col-spaced'>
                                                <div className="field-label">
                                                    Disponibilidad semanal
                                                </div>
                                                <div className="field-value">
                                                {data.weekly_availability_days + ' día(s)' || 'No disponible'}
                                                </div>
                                            </Col>  

                                            <Col xs={24} md={6} className='col-spaced'>
                                                <div className="field-label">
                                                    Equipo o Gimnasio
                                                </div>
                                                <div className="field-value">
                                                    <Radio.Group 
                                                        value={data?.has_gym_equipment} 
                                                        readonly
                                                    >
                                                        <Radio value={true}>Sí</Radio>
                                                        <Radio value={false}>No</Radio>
                                                    </Radio.Group>
                                                </div>
                                            </Col>
                                            <Col xs={24} md={24}>
                                                <Divider orientation="left">Consentimiento y Privacidad</Divider>
                                            </Col>
                                            <Col xs={24} md={24}>
                                                <Space direction="vertical">
                                                    <Checkbox 
                                                        checked={data?.accept_terms || false}
                                                        readonly
                                                    >
                                                        Acepto los términos y condiciones
                                                    </Checkbox>
                                                    <Checkbox 
                                                        checked={data?.allow_marketing || false}
                                                        readonly
                                                    >
                                                        Acepto recibir información y promociones
                                                    </Checkbox>
                                                    <Checkbox 
                                                        checked={data?.allow_analytics || false}
                                                        readonly
                                                    >
                                                        Autorizo el uso de mis datos para fines estadísticos anónimos
                                                    </Checkbox>
                                                </Space>
                                            </Col>

                                        </Row> 
                                   
                                ),
                            },
                            {
                                key: 'social',
                                label: 'Social',
                                children: (
                                
                                    <Row gutter={16}>
                                        <Col xs={24} md={6}>
                                            <div style={{ 
                                            display: 'flex', 
                                            flexDirection: 'column', 
                                            alignItems: 'center',
                                            gap: 16 
                                            }}>
                                            <Avatar
                                                size={160}
                                                src={data.photo_url ? resolveMedia(data.photo_url) : null}
                                                icon={<UserOutlined />}
                                                style={{ 
                                                fontSize: '48px',
                                                border: '3px solid #f0f0f0'
                                                }}
                                            />
                                            </div>
                                        </Col>
                                        <Col xs={24} md={18}>
                                            <Row gutter={16}>
                                                <Col xs={24} md={8} className='col-spaced'>
                                                    <div className="field-label">
                                                    Nickname
                                                    </div>
                                                    <div className="field-value">
                                                    {data.nickname || 'No disponible'}
                                                    </div>
                                                </Col>
                                            </Row> 
                                        </Col>
                                        </Row> 
                                ),
                            },
                            {
                                key: 'history',
                                label: 'Historial',
                                children: <ClientSubscriptionsHistory clientId={id} />,
                            },
                        ]}
                    />


      </Card>
    </div>
  );
};

export default ClientViewPage;